import { CustomColumnType } from "./grid-column-types";
import { dateBasedYearFormatter, multiplyFormatter, percentageFormatter } from "./value-formatters";
import { numberFormatters } from "common";
import { getDateString } from "common/date-utils";
import { NumberFormatKind } from "common/types";
export const processPercentageCellCallback = (params) => percentageFormatter({
    value: params.value
});
export const processSparklineCellCallback = (params) => {
    const sorted = params.value?.slice().sort((a, b) => b.y - a.y);
    return `max: ${sorted[0].y}, min: ${sorted[sorted.length - 1].y}`;
};
export const processMultiplyCellCallback = (params) => multiplyFormatter({
    value: params.value
});
export const processDateBasedYearCellCallback = (params) => dateBasedYearFormatter({
    context: params.context,
    value: params.value
});
export const processMoneyCellCallback = (params, dataScale) => {
    if (params.value) {
        const { currency } = params.value;
        const value = params.value.value || params.value.amount;
        return (value || value === 0) && !isNaN(value) && currency
            ? `${numberFormatters(value, NumberFormatKind.compact, { maximumFractionDigits: 2, minimumFractionDigits: 2 }, dataScale)} ${currency}`
            : value;
    }
    return "";
};
export const processUnitCellCallback = (params, dataScale) => {
    if (params.value) {
        const { unit } = params.value;
        const value = params.value.value || params.value.unit;
        return (value || value === 0) && !isNaN(value) && unit
            ? `${numberFormatters(value, NumberFormatKind.default, { maximumFractionDigits: 2, minimumFractionDigits: 2 }, dataScale)} ${unit}`
            : value;
    }
    return "";
};
export const processAreaCellCallback = (params, dataScale) => {
    if (params.value) {
        const { unit } = params.value;
        const value = params.value.value || params.value.area;
        return (value || value === 0) && !isNaN(value) && unit
            ? `${numberFormatters(value, NumberFormatKind.default, { maximumFractionDigits: 2, minimumFractionDigits: 2 }, dataScale)} ${unit}`
            : value;
    }
    return "";
};
export const processDateCellCallback = (params) => {
    const { value } = params;
    if (value === null) {
        return "";
    }
    let date = null;
    if (typeof value === "string") {
        const mlsec = Date.parse(value);
        if (!isNaN(mlsec)) {
            date = new Date(mlsec);
        }
    }
    else if (typeof value === "object") {
        const { year, month, day } = value;
        if (year && month && day) {
            date = new Date(year, month - 1, day);
        }
    }
    return date ? getDateString(date) : "";
};
export const columnCellCallbacks = {
    [CustomColumnType.InsSparklineColumn]: processSparklineCellCallback,
    [CustomColumnType.InsMultiplyColumn]: processMultiplyCellCallback,
    [CustomColumnType.InsMoneyColumn]: processMoneyCellCallback,
    [CustomColumnType.InsUnitColumn]: processUnitCellCallback,
    [CustomColumnType.InsDateBasedYearColumn]: processDateBasedYearCellCallback,
    [CustomColumnType.InsDateColumn]: processDateCellCallback,
    [CustomColumnType.InsDateGroupColumn]: processDateCellCallback,
    [CustomColumnType.InsPercentageColumn]: processPercentageCellCallback,
    [CustomColumnType.InsAreaColumn]: processAreaCellCallback
};
